// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class QuoteArchiveResult {
  readonly id: string;
  readonly isArchived: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
  }

  static zero(): QuoteArchiveResult {
    const zeroValues: ExcludeMethodsDeep<QuoteArchiveResult> = {
      id: NIL_UUID,
      isArchived: false,
    };
    return new QuoteArchiveResult(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteArchiveResultWireFormat = {
  id: string;
  isArchived: boolean;
};

type NewQuoteArchiveResultProps = PartialDeep<QuoteArchiveResult, { recurseIntoArrays: true }>;
export const NewQuoteArchiveResult: (props: NewQuoteArchiveResultProps) => QuoteArchiveResult = (
  props,
) => new QuoteArchiveResult(props);

type NewQuoteArchiveResultFromWireFormatProps = PartialDeep<
  QuoteArchiveResultWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteArchiveResultFromWireFormat: (
  props: NewQuoteArchiveResultFromWireFormatProps,
) => QuoteArchiveResult = (props) => new QuoteArchiveResult(props);
